import { UMIcon, UMR } from '../../urbanmap/_components';
import { plansUsing } from './model';
import { FAMILIES, type AnySet, type Family, type Project } from './types';
import { ACCENT } from './ui';

interface Props {
  project: Project;
  active: Family;
  onSelectFamily: (f: Family) => void;
  onHome: () => void;
}

/**
 * Liste latérale COMPACTE des 6 familles (icône + nom + compteur, famille active surlignée).
 * Permet de passer d'une famille à l'autre sans revenir à l'accueil en tuiles.
 */
export function FamilyNav({ project, active, onSelectFamily, onHome }: Props) {
  return (
    <nav aria-label="Familles d’hypothèses" style={{ flex: '0 0 196px', width: 196, borderRight: `1px solid ${UMR.border}`, background: UMR.white, overflowY: 'auto', padding: 8, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <button type="button" onClick={onHome} title="Revenir à l’accueil des familles"
        style={{ cursor: 'pointer', fontFamily: UMR.font, border: 0, background: 'transparent', color: UMR.textSecondary, display: 'flex', alignItems: 'center', gap: 6, padding: '6px 8px', fontSize: 12 }}>
        <UMIcon name="grid_view" size={16} color={UMR.textSecondary} /> Toutes les familles
      </button>
      {FAMILIES.map((f) => {
        const sets = project.sets[f.key] as AnySet[];
        const used = sets.filter((s) => plansUsing(project, f.key, s.id).length).length;
        const on = f.key === active;
        return (
          <button
            key={f.key}
            type="button"
            aria-current={on ? 'true' : undefined}
            onClick={() => onSelectFamily(f.key)}
            style={{
              cursor: 'pointer', fontFamily: UMR.font, textAlign: 'left',
              border: `1px solid ${on ? ACCENT : 'transparent'}`,
              borderLeft: `3px solid ${on ? ACCENT : 'transparent'}`,
              background: on ? 'var(--nj-core-color-teal-100, #e3f4f2)' : 'transparent',
              color: on ? ACCENT : UMR.text,
              display: 'flex', alignItems: 'center', gap: 8, padding: '8px 8px', borderRadius: 4,
            }}
          >
            <UMIcon name={f.icon} size={20} color={on ? ACCENT : UMR.textSecondary} />
            <span style={{ flex: 1, minWidth: 0 }}>
              <span style={{ display: 'block', fontSize: 13, fontWeight: on ? 700 : 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.label}</span>
              <span style={{ display: 'block', fontSize: 11, color: UMR.textSecondary }}>{sets.length} jeu{sets.length > 1 ? 'x' : ''}{used ? ` · ${used} utilisé${used > 1 ? 's' : ''}` : ''}</span>
            </span>
            {f.map !== 'none' && <UMIcon name="map" size={14} color={UMR.textSecondary} style={{ opacity: 0.7 }} />}
          </button>
        );
      })}
    </nav>
  );
}
